import React from 'react';
import SalesIndex from '../impact';

export default function () {
  return <SalesIndex noFixedVideo noExitIntent noShareButtons ctaNoTimer ctaOverride="sales97" variant="ad" />;
}
